import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { GoodsReceiptSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { createGoodsReceiptSearchSchema } from "@/screens/WarehouseReceiving/schemas"
import { IncomingGoodsReceiptsContainer } from "@/screens/WarehouseReceiving/subfeatures/Incoming/components"

export const Route = createFileRoute("/app/warehouse-receiving/_layout/incoming")({
  validateSearch: zodValidator(
    createGoodsReceiptSearchSchema(GoodsReceiptSortField.EstimatedDeliveryDate, SortingOrder.Asc)
  ),
  component: () => <IncomingGoodsReceiptsContainer />,
})
